import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CheckCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"check_circle"}/>
}
